export default __webpack_public_path__ + "static/media/valhime_wide.5117b595.png";